<template>
    <section class="section_news containerg sectiune_generala">
        <div  v-for="imagine in articole.image" :key="imagine.thumbnailpath" class="img_articol">
                    <img :src="imagine.thumbnailpath" />
        </div>
        <div class="articol_right">
            <div class="title_articole">{{ articole.title }}</div>
            <div class="date_news"><i class="ri-time-fill"></i>{{ articole.created_at | formatDate }}</div>
            <div class="cont_articol"  v-html="articole.description"></div>
        </div>
    </section>
</template>
<script>
  import moment from 'moment'
  import axios from 'axios';
    import Vue from 'vue';
    import VueFilterDateFormat from 'vue-filter-date-format';

    Vue.use(VueFilterDateFormat);
 
  export default {
      data() {
      return {
        articole : []
      }
    },
    mounted () {
      axios.get('https://xpanel.tikibistro.ro/api/news?t='+Number(new Date()),{
            withCredentials: false,
        })
        .then(response => {
            
            if(response.data.data.length)
            {
                for(var i=0;i<response.data.data.length;i++)
                {
                    if(response.data.data[i].id == this.$route.params.id)
                    {
                        this.articole = response.data.data[i];
                    }
                }
            }
            console.log(this.articole);
        })

    },
    filters: {
        formatDate: function(date) {
            return moment.unix(date).lang("ro").format('DD MMMM YYYY')
        }
    }
   
  }
</script>